import React from 'react';

const NotFound = () => {
  return (
    <div>
      <h1>Não Encontrada!</h1>
      <p className="lead">A página que você está acessando não existe.</p>
    </div>
  )
};

export default NotFound;
